module.exports = __webpack_public_path__ + "img/careers_16x9_poster.d8325eb.jpg";